export const contactDetailTabs = [
  {
    label: "General Details",
    value: "General Details",
    index: 0,
  },
  {
    label: "Address Details",
    value: "Address Details",
    index: 1,
  },
  {
    label: "Invoice",
    value: "Invoice",
    index: 2,
  },
  {
    label: "Credit Note",
    value: "Credit Note",
    index: 3,
  },
  {
    label: "Receipt",
    value: "Receipt",
    index: 4,
  },
  {
    label: "Payment",
    value: "Payment",
    index: 5,
  },
  {
    label: "Product List",
    value: "product_list",
    index: 6,
  },
  {
    label: "Customer Loyalty Ledger",
    value: "Customer Loyalty Ledger",
    index: 7,
  },
];

export const supplierDetailTabs = [
  {
    label: "General Details",
    value: "General Details",
    index: 0,
  },
  {
    label: "Address Details",
    value: "Address Details",
    index: 1,
  },
  {
    label: "Supplier Bill",
    value: "Supplier Bill",
    index: 2,
  },
  {
    label: "Debit Note",
    value: "Debit Note",
    index: 3,
  },
  {
    label: "Expense",
    value: "Expense",
    index: 4,
  },
  {
    label: "Receipt",
    value: "Receipt",
    index: 5,
  },
  {
    label: "Payment",
    value: "Payment",
    index: 6,
  },
  {
    label: "Product List",
    value: "product_list",
    index: 7,
  },
];

export const transportDetailTabs = [
  {
    label: "General Details",
    value: "General Details",
    index: 0,
  },
  {
    label: "Address Details",
    value: "Address Details",
    index: 1,
  },
  {
    label: "Expense",
    value: "Expense",
    index: 2,
  },

  {
    label: "Receipt",
    value: "Receipt",
    index: 3,
  },
  {
    label: "Payment",
    value: "Payment",
    index: 4,
  },
];
